import { records as appStorageRecords } from '@saucelabs/sl-module-app-storage';

import { GlobalState } from '../../reducers';
import { Preset } from './records';
import { PresetsState } from './reducers';

const presetsSelector = (store: GlobalState): PresetsState => store.apps.manual.presets;

const getAppForPreset = (preset: Preset) => (
  (store: GlobalState): appStorageRecords.AppStorageFile | null => {
    const matchingApp = store.apps.manual.presets.apps.find(
      (appItem) => appItem.id === preset.getAppId()) as appStorageRecords.AppStorageFile;

    return matchingApp || null;
  }
);

export default {
  presetsSelector,
  getAppForPreset,
};
